export enum ImportTemplateType {
    ZONING_CODE = 'ZONING_CODE',
    ZONE_DESCRIPTIONS = 'ZONE_DESCRIPTIONS',
    CALIBRATION_SET_TABLE_FIELD_ATTRIBUTES = 'CALIBRATION_SET_TABLE_FIELD_ATTRIBUTES',
    ZONE_COMBINATION_USES_VALUES = 'ZONE_COMBINATION_USES_VALUES',
    ZONE_COMBINATION_CALIBRATION_GENERAL_VALUES = 'ZONE_COMBINATION_CALIBRATION_GENERAL_VALUES',
    ZONE_COMBINATION_CALIBRATION_USE_CAPACITY_VALUES = 'ZONE_COMBINATION_CALIBRATION_USE_CAPACITY_VALUES'
}
